import apiClient from './client';

export const chargebacksApi = {
  getEligibleParts: async (params = {}) => {
    const { oem, period_start, period_end, program } = params;
    const queryParams = new URLSearchParams();
    
    if (oem) queryParams.append('oem', oem);
    if (period_start) queryParams.append('period_start', period_start);
    if (period_end) queryParams.append('period_end', period_end);
    if (program) queryParams.append('program', program);
    
    const response = await apiClient.get(`/api/v1/chargebacks/eligible-parts?${queryParams}`);
    return response.data;
  },

  createChargeback: async (data) => {
    const response = await apiClient.post('/api/v1/chargebacks', data);
    return response.data;
  },

  generatePdf: async (chargebackId) => {
    const response = await apiClient.post(`/api/v1/chargebacks/${chargebackId}/generate-pdf`);
    return response.data;
  }
};
